import React from "react";
import { Box, Typography } from "@mui/material";

interface BrandLogoProps {
  size?: "small" | "large";
  isDark?: boolean;
}

const BrandLogo: React.FC<BrandLogoProps> = ({ size = "small", isDark = false }) => {
  const isLarge = size === "large";

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
      }}
    >
      <Box
        component="img"
        src={isDark ? "/images/fongfluency_logo_dark.png" : "/images/fongfluency_logo.png"}
        alt="FongFluency Logo"
        sx={{
          width: isLarge ? "54px" : "36px",
          height: isLarge ? "54px" : "36px",
          objectFit: "contain",
          mixBlendMode: isDark ? "normal" : "multiply",
        }}
      />
      <Box>
        <Typography
          sx={{
            fontSize: isLarge ? "30px" : "19px",
            fontWeight: "800",
            color: isDark ? "#fff" : "#264653",
            letterSpacing: "-0.05em",
            fontFamily: "'Inter', sans-serif",
            lineHeight: 1,
          }}
        >
          FongFluency
        </Typography>
      </Box>
    </Box>
  );
};

export default BrandLogo;
